module.exports = __webpack_public_path__ + "assets/img/covers.21fd9c5a.jpg";